import type { SxProps } from '@mui/material';

export const rootSx: SxProps = {
  my: 2,
};
